// Libraries
import React from 'react';

// Supermove
import {gql} from '@supermove/graphql';
import {ProjectModel} from '@supermove/models';

// App
import DropdownButton from '@shared/design/components/Button/DropdownButton';
import SkeletonLoader from '@shared/design/components/SkeletonLoader';
import ProjectDetailsBlockHeader, {
  BlockHeaderLoader,
} from '@shared/modules/Project/components/widgets/components/ProjectDetailsBlockHeader';
import ProjectDetailsBlockWrapper from '@shared/modules/Project/components/widgets/components/ProjectDetailsBlockWrapper';
import ProjectProposalsBlockActions from '@shared/modules/Project/components/widgets/components/ProjectProposalsBlockActions';
import ProjectProposalsTable from '@shared/modules/Project/components/widgets/components/ProjectProposalsTable';
import {ProjectBlockKindType} from '@shared/modules/Project/enums/ProjectBlockKind';

const SkeletonComponent = () => {
  return (
    <React.Fragment>
      <BlockHeaderLoader
        title={'Proposals'}
        ActionsComponent={() => <DropdownButton isDisabled isSmall text={'Send'} actions={[]} />}
      />
      <SkeletonLoader height={150} isFullWidth />
    </React.Fragment>
  );
};

const ProjectProposalsBlockContent = ({
  project,
  refetch,
  handleUpdateBlock,
}: {
  project: ProjectModel;
  refetch: () => void;
  handleUpdateBlock: (block: ProjectBlockKindType) => void;
}) => {
  return (
    <React.Fragment>
      <ProjectDetailsBlockHeader
        title={`Proposals`}
        ActionsComponent={ProjectProposalsBlockActions}
        actionsComponentProps={{project, refetch, handleUpdateBlock}}
        style={{zIndex: 1}}
      />
      <ProjectProposalsTable.Mobile project={project} handleUpdateBlock={handleUpdateBlock} />
    </React.Fragment>
  );
};

const ProjectProposalsBlock = ({
  index,
  projectUuid,
  handleUpdateBlock,
}: {
  index: number;
  projectUuid: string;
  handleUpdateBlock: (block: ProjectBlockKindType) => void;
}) => {
  return (
    <ProjectDetailsBlockWrapper
      index={index}
      query={ProjectProposalsBlock.query}
      queryVariables={{projectUuid}}
      SkeletonComponent={SkeletonComponent}
    >
      {({data, refetch}: {data: {project: ProjectModel}; refetch: () => void}) => {
        return (
          <ProjectProposalsBlockContent
            project={data.project}
            refetch={refetch}
            handleUpdateBlock={handleUpdateBlock}
          />
        );
      }}
    </ProjectDetailsBlockWrapper>
  );
};

// --------------------------------------------------
// Data
// --------------------------------------------------
ProjectProposalsBlock.query = gql`
  ${ProjectProposalsBlockActions.fragment}
  ${(ProjectProposalsTable.Mobile as any).fragment}

  query ProjectProposalsBlock($projectUuid: String!) {
    ${gql.query}
    project(uuid: $projectUuid) {
      id
      ...ProjectProposalsBlockActions
      ...ProjectProposalsTable_Mobile
    }
  }
`;

export default ProjectProposalsBlock;
